import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BootstrapLibModule } from './bootstrap/bootstraplib.module';
import { MaterialLibModule } from './material/materiallib.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    BootstrapLibModule,
    MaterialLibModule
  ],
  exports: [
    BootstrapLibModule,
    MaterialLibModule,
  ]
})
export class LibModule { }
